import React, { useState, useEffect } from 'react';

const BrowserCompatibility = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [browserInfo, setBrowserInfo] = useState(null);

  useEffect(() => {
    const detectBrowser = () => {
      const userAgent = navigator.userAgent;
      let browserName = "Unknown";
      let browserVersion = "Unknown";
      let isSupported = true;

      // Детекція Internet Explorer
      if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) {
        browserName = "Internet Explorer";
        const match = userAgent.match(/(?:MSIE |rv:)(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 11;
      }
      // Детекція Edge Legacy
      else if (userAgent.indexOf("Edge/") !== -1) {
        browserName = "Microsoft Edge Legacy";
        const match = userAgent.match(/Edge\/(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 79;
      }
      // Детекція Edge Chromium
      else if (userAgent.indexOf("Edg/") !== -1) {
        browserName = "Microsoft Edge";
        const match = userAgent.match(/Edg\/(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 79;
      }
      // Детекція Chrome
      else if (userAgent.indexOf("Chrome") !== -1 && userAgent.indexOf("Edg") === -1) {
        browserName = "Google Chrome";
        const match = userAgent.match(/Chrome\/(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 60;
      }
      // Детекція Firefox
      else if (userAgent.indexOf("Firefox") !== -1) {
        browserName = "Mozilla Firefox";
        const match = userAgent.match(/Firefox\/(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 60;
      }
      // Детекція Safari
      else if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) {
        browserName = "Safari";
        const match = userAgent.match(/Version\/(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 12;
      }
      // Детекція Opera
      else if (userAgent.indexOf("OPR") !== -1 || userAgent.indexOf("Opera") !== -1) {
        browserName = "Opera";
        const match = userAgent.match(/(?:OPR|Opera)\/(\d+)/);
        browserVersion = match ? match[1] : "Unknown";
        isSupported = parseInt(browserVersion) >= 60;
      }

      // Перевірка підтримки ключових функцій
      const supportsEssentialFeatures =
        typeof Promise !== 'undefined' &&
        typeof fetch !== 'undefined' &&
        typeof Object.assign === 'function' &&
        typeof Array.from === 'function';

      const finalSupported = isSupported && supportsEssentialFeatures;

      setBrowserInfo({
        name: browserName,
        version: browserVersion,
        isSupported: finalSupported,
        userAgent: userAgent
      });

      // Показати попередження, якщо браузер не підтримується
      if (!finalSupported) {
        setShowWarning(true);
      }
    };

    detectBrowser();
  }, []);

  const dismissWarning = () => {
    setShowWarning(false);
    localStorage.setItem('dismissedBrowserWarning', 'true');
  };

  useEffect(() => {
    const dismissed = localStorage.getItem('dismissedBrowserWarning');
    if (dismissed === 'true') {
      setShowWarning(false);
    }
  }, []);

  if (!showWarning || !browserInfo || browserInfo.isSupported) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#f59e0b',
        color: '#ffffff',
        padding: '12px',
        textAlign: 'center',
        zIndex: 10000,
        fontSize: '14px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, marginRight: '16px' }}>
          <strong>⚠️ Застарілий браузер:</strong> Ви використовуєте {browserInfo.name} {browserInfo.version}.
          Для кращої роботи застосунку рекомендуємо оновити браузер або використовувати:
          <br />
          <span style={{ fontSize: '12px' }}>
            Chrome 60+, Firefox 60+, Safari 12+, Edge 79+ або IE 11+
          </span>
        </div>
        <button
          onClick={dismissWarning}
          style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.3)',
            color: '#ffffff',
            padding: '6px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px',
            marginLeft: '8px'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'rgba(255,255,255,0.3)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
          }}
        >
          ✕ Закрити
        </button>
      </div>
    </div>
  );
};

export default BrowserCompatibility;